import Release2510Page from '../pages/Release2510Page';
import Release2610Page from '../pages/Release2610Page';

// Update this constant each year to point to the newest release.
export const LATEST_RELEASE = '2610';

// Add a new entry here when a new yearly release is created.
// Each entry: { slug: string (4-digit), component: React.ComponentType }
export const RELEASE_ROUTES = [
  { slug: '2510', component: Release2510Page },
  { slug: '2610', component: Release2610Page },
];
